<template>
  <div class="d-flex flex-column">
    <v-sheet class="py-10 pl-4 pr-16 transparent">
      <span class="text-h5 title">
        {{ title }}
      </span>
    </v-sheet>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: "Poppins", "Sans-serif";
  font-size: 19.2px;
  color: $neutral-700;
}
</style>
